import { BFormInput } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormInput when migrating. */
export const EgBFormInput = createEgBootstrapProxy("EgBFormInput", BFormInput);
